// extracted by mini-css-extract-plugin
export default {"wrapper":"Chat_wrapper__VAE3i"};